<div id="sc-chatbot-overlay" #chatbotOverlay>

  <div id="sc-chatbot-backdrop" (click)="hide()"></div>

  <div id="sc-chatbot-container">
    <sc-chatbot-chat-header [chat]="chat" [showHide]="true" (hide)="hide()" [showBack]="false" [showRestart]="showRestart && hasUserMessage" (restart)="isRestartConfirmVisible = true"></sc-chatbot-chat-header>
    @if (chat) {
      <sc-chatbot-stream #chatbotStream [chat]="chat" (onEndOfChat)="handleEndOfChat($event)" (hasUserMessageChange)="hasUserMessage = $event"></sc-chatbot-stream>
    }
    <div class="restart-confirm" [class.is-active]="isRestartConfirmVisible">
      <div class="h3 mb-4">Chat neu starten?</div>
      <div class="d-flex justify-content-center">
        <button class="btn btn-secondary btn-round me-2" (click)="isRestartConfirmVisible = false">Abbrechen</button>
        <button class="btn btn-dark btn-round" (click)="confirmRestart()">Neu starten</button>
      </div>
    </div>
  </div>

</div>

<sc-chatbot-trigger-button #chatbotTrigger [class.d-none]="isActive" class="d-md-block" (click)="toggle()"></sc-chatbot-trigger-button>